<template>
  <div>
	<div class="loading" v-if="loading">
   
<div class="loader">
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
    </div>
  <div v-if="fetch">
	
		<div class="wrap-slick1 rs1-slick1 shophome" >
			<div class="slick1 shophome">
				<div class="item-slick1 shophome" :style="{ backgroundImage: 'url(' + homeimg + ')' }">
					<div class="container h-full" style="background-color: #3333336e;">
						<div class="flex-col-l-m h-full p-t-0 p-b-30 m-p-t-00">
							
							<div class="">
								<h2 class="ltext-104 cl15 p-t-1 p-b-25 respon1 animated flip slower delay-3s" :style="{color:color1}">
									{{name}}
								</h2>
							</div>
								
								<!-- <div class="animated lightSpeedIn slower delay-2s p-b-12" >
								<span class="ltext-202 cl1 respon2 p-b-20" :style="{color:color1}">
									Open {{stime}} AM - Close {{etime}} PM
								</span>
							</div> -->
								
								<div class="animated lightSpeedIn slower delay-2s" v-if="tel1 != ''">
								<span class="ltext-202 cl1 respon2" :style="{color:color1}">
									+94 {{tel1}}
								</span>
							</div>
							<a v-if="shops[0].details.lat && shops[0].details.lng" :href="`https://maps.google.com/?q=${shops[0].details.lat}, ${shops[0].details.lng}`" target="_blank" rel="noopener noreferrer"><el-button size="small" type="success" class="mt-3">Get Direction</el-button></a>
						</div>
					</div>
				</div>
			</div>
		</div>
	  <section class=" section" style="padding-top:30px;">
	<!-- Container Start -->
	<div class="container">
		<div v-if="show">
			<div v-if="shops3[0].gallery.length >0">
				<div class="p-b-10">
					<h3 class="ltext-103 cl5 text-center">
						Store overview
					</h3>
				</div>
				<div class="row">
				<div class="col-lg-8 col-md-10 col-12 mx-auto">
						<el-carousel :interval="2000" :type="type"  >
						<el-carousel-item v-for="(item , i) in shops3[0].gallery" :key="i">
							<div :style="{backgroundImage: 'url(' + item + ')'}" style="width:100%; height:100%; overflow:hidden; display: block; background-position: 50%;background-repeat: no-repeat;background-size: contain;" class="mx-auto"></div>
						</el-carousel-item>
					</el-carousel>
					</div>
			</div>
			</div>
		</div>
		
		<div class="row">

			<div class="row mt-1 mx-auto" v-if="darea != undefined">			
					<div class="col-lg-10  col-md-10  col-sm-10 mx-auto" 
					 style="height:auto;">
						<div class="category-block" style="background-color: #fff;">
							<div class="header">
								<i class="fa fa-truck icon-bg-1"></i> 
								<h4><a>Delivery Details & Special Notes</a></h4>
							</div>
							<ul class="category-list" >
								<li><span>{{darea}}</span></li>			
							</ul>
						</div>
					</div>		
				</div>

				
			<!-- <div class="col-12" v-if="plan != 'Starter'">
				
				<div class="section-title" style="margin-bottom: 40px;">
					<h2>Categories</h2>
				
				</div>
			
						<div class="row">
					
					<div class="col-lg-3 offset-lg-0 col-md-4 offset-md-1 col-sm-6" 
					v-for="(values, key) in shopcats" :key="key" style="height:auto;">
						<div class="category-block">
							<div class="header">
								<i class="fa fa-tag icon-bg-1"></i> 
								<h4><a>{{key}}</a></h4>
							</div>
							<ul class="category-list" >
								<li  v-for="(value, key) in values" :key="key" v-if="value > 0"><router-link  :to="{name: 'storeproducts', params: {cat: key}}">{{key}}<span>{{value}}</span></router-link></li>
							
							</ul>
						</div>
					</div>
					
				</div>
			</div> -->

			
		</div>
		
		<div>
		<div class="p-b-10">
				<h3 class="ltext-103 cl5 text-center">
					Categories
				</h3>
			</div>
		
				<div class="row mt-3">
					
					<div class="col-lg-3 offset-lg-0 col-md-4 offset-md-1 col-sm-6" 
					v-for="(values, key) in shopcats" :key="key" style="height:auto;">
						<div class="category-block" style="background-color: #fff;">
							<div class="header">
								<i class="fa fa-tag icon-bg-1"></i> 
								<h4><a>{{key}}</a></h4>
							</div>
							<ul class="category-list" >
								<li  v-for="(value, key) in values" :key="key" v-if="value > 0"><router-link  :to="{name: 'storeproducts', params: {cat: key}}">{{key}}<span>{{value}}</span></router-link></li>
							
							</ul>
						</div>
					</div>
					
				</div>
				<!-- <div class="flex-w flex-l-m filter-tope-group m-tb-10 " >
					<button @click="filterProduct('')" v-if="plan == 'Starter'" class="stext-110 cl6 hov1 bor3 trans-04 m-r-32 m-tb-25 how-active1" >
						All Products
					</button>
					
					<button @click="filterProduct('latest')"  v-if="plan == 'Starter'" class="stext-110 cl6 hov1 bor3 trans-04 m-r-32 m-tb-25" >
						Latest
					</button>

					<button @click="filterProduct('bestselling')"  v-if="plan == 'Starter'" class="stext-110 cl6 hov1 bor3 trans-04 m-r-32 m-tb-25" >
						Best Selling
					</button>

						<button @click="changeItems('bestselling')" v-if="plan != 'Starter'"  class="stext-110 cl6 hov1 bor3 trans-04 m-r-32 m-tb-25 how-active1 text-center" >
						Best Selling
					</button>
					<button @click="changeItems('latest')" v-if="plan != 'Starter'" class="stext-110 cl6 hov1 bor3 trans-04 m-r-32 m-tb-25" >
						Latest
					</button>

				</div> -->

		<!-- <div class="row isotope-grid">
				<template v-for=" (item, i) in products" > 
					<div class="col-6 col-sm-4 col-md-4 col-lg-3 p-b-35 isotope-item men" v-bind:key="item.id" >
				
					<div class="block2 " style="box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.1);">
						<div class="block2-pic hov-img0" >
							<div :src="item.image" class="zoom">
						
								<img :src="item.image" style="cursor:pointer;" @click="showDesc(item.desc)" alt="IMG-PRODUCT">
							
							</div>
							
						</div>

						<div class="block2-txt flex-w flex-t p-t-14" style="padding: 20px;">
							<div class="block2-txt-child1 flex-col-l ">
								<a class="stext-104 cl6 hov-cl13 text-info trans-04 m-txt js-name-b2 p-b-6" 
								style="font-size: 16px; font-weight: 500; cursor:pointer;" @click="showDesc(item.desc)">
									{{item.name}}
								</a>

								<span class="stext-105 cl3" v-if="plan == 'Starter'">
									<span class="stext-105 cl15 m-txt" style="color:#F03B3B; display:block;">RS {{item.price}}</span>
								</span>
								<span v-if="plan != 'Starter'">
								<span class="stext-105 cl3" v-if="(item.disprice != item.price )">
									<span class="stext-105 cl15 m-txt" style="color:#F03B3B; display:block;">RS {{item.price}}</span>
									<span class="stext-105 cl3 m-txt" style="text-decoration: line-through;">
									RS {{item.disprice}}
									</span>
								</span>
								<span class="stext-105 cl3 text-info m-txt" v-if="(item.disprice == item.price )">
									RS {{item.price}}
								</span>
								</span>
								<social-sharing url="https://eshops.lk/#/stores/ST4o2XjscmVCLIps1YjlzjXzOxF2/productdetails/GF9hoetQoXjbFwlMQZPb"
                      :title="item.name"
                      :description="item.desc"
                      quote="Vue is a progressive framework for building user interfaces."
                      hashtags="vuejs,javascript,framework"
                      inline-template>
											<div>
													<network network="email">
															<i class="fa fa-envelope"></i> Email
													</network>
													<network network="facebook">
														<i class="fa fa-facebook"></i> Facebook
													</network>
												
													<network network="sms">
														<i class="fa fa-commenting-o"></i> SMS
													</network>
												
													<network network="whatsapp">
														<i class="fa fa-whatsapp"></i> Whatsapp
													</network>
											</div>
										</social-sharing>
							</div>

							<div class="block2-txt-child2 flex-r p-t-3">

								
							</div>
						</div>
					</div>
				</div>
				</template>
				
			
		</div> -->
		</div>

		<!-- <h3 v-if="this.products.length > 0" class="mt-5 mb-3 text-center text-dark">All </h3> -->
		<div class="p-b-10" v-if="this.products.length > 0">
			<h3 class="ltext-103 cl5 text-center">
				All Products
			</h3>
		</div>
    <div v-if="this.products.length > 0" class="container pb-4">
      <div class="row">
        <div class="col-6 col-sm-4 col-md-4 col-lg-3 my-2" v-for="(p,i) in products" :key="i">
          <el-card :body-style="{ padding: '0px' }">
            <div class="" :style="{backgroundImage: 'url(' + p.image + ')'}" style="width: 100%; height:300px; overflow:hidden; display: block; background-position: 50%;background-repeat: no-repeat;background-size: cover; cursor:pointer;" @click="showDetails(p)"></div>
            <div style="padding: 14px;">
              <span class="text-primary"> {{p.name}}</span>
              <p class="my-1"><i class="fa fa-tag text-primary mr-1"></i> {{p.subcat}}</p>
              <p class="my-1">
							
									<span class="stext-105 cl15 m-txt" v-if="(p.disprice != p.price )" style="color:#F03B3B; display:block;"><i class="fa fa-tag text-primary mr-1"></i>RS {{p.price}}</span>
									<span class="stext-105 cl3 m-txt" v-if="(p.disprice != p.price )" style="text-decoration: line-through;"><i class="fa fa-tag text-primary mr-1"></i>
									RS {{p.disprice}}
									</span>
								
								<span class="stext-105 cl3 text-info m-txt" v-if="(p.disprice == p.price )"><i class="fa fa-tag text-primary mr-1"></i>
									RS {{p.price}}
								</span>
							</p>
              
            </div>
          </el-card>
        </div>
      </div>
    </div>
	</div>
</section>
		
  </div>
  </div>
</template>

<script>
import db from "../../config/FirebaseInit"
import firebase from 'firebase/app';
// import Banner from './Banner'

export default {
  name: 'home',
  components: {
	 
  },
   data (){
    return{
			modalShow:false,
			desc:'',
       latestItems: [],
        saleItems: [],
		bestSelling: [],
		loading:false,
		fetch:false,
		show:false,
		slide: 0,
      sliding: null,
		
		shops:[],
		shops2:[],
		shops3:[],
		stime:'',
		etime:"",
		name:'',
		darea:'',
		tel1:'',
		homeimg:'',
		shopcats:{},
		shopcat:'',
		plan:'',
		products:[],
		allProducts:[],
		color1:'',
		secondaryDatabase:{},
		type:'',

    }
	},
	methods:{
		 backToTop: function() {
      $('html,body').stop().animate({
        scrollTop: 0
      }, 'fast', 'swing');
		},
		showDetails(p){
			this.$router.push({name: 'storeproductdetails', params: {id: p.id}})
		},
		showDesc(desc) {
				var regExp = RegExp(/<[^>]*>/g)
				if(regExp.test(desc) === true){
					this.desc = 'No product details'
					//console.log('1', this.desc);
					this.$alert(this.desc, 'Product Details', {
          dangerouslyUseHTMLString: true
					});
					return false
				}else if ((desc===null) || (desc==='') || (desc===undefined)){
					this.desc = 'No product details'
					//console.log('2', this.desc);
					this.$alert(this.desc, 'Product Details', {
          dangerouslyUseHTMLString: true
					});
					return false;
				}else{
					desc = desc.toString();
					this.desc =	desc.replace(/<[^>]*>/g, '');

					//textarea is reference to that object, "<br>" is string that will replace the encoded return
					this.desc = escape(this.desc) 
					//encode textarea string's carriage returns

					for(var i=0; i<this.desc.length; i++){ 
					//loop through string, replacing carriage return encoding with HTML break tag

					if(this.desc.indexOf("%0D%0A") > -1){ 
					//Windows encodes returns as \r\n hex
					this.desc=this.desc.replace("%0D%0A","<br>")
					}
					else if(this.desc.indexOf("%0A") > -1){ 
					//Unix encodes returns as \n hex
					this.desc=this.desc.replace("%0A","<br>")
					}
					else if(this.desc.indexOf("%0D") > -1){ 
					//Macintosh encodes returns as \r hex
					this.desc=this.desc.replace("%0D","<br>")
					}

					}
					this.desc=unescape(this.desc) 
					//console.log('4', this.desc);
					//unescape all other encoded characters
					this.$alert(this.desc, 'Product Details', {
						dangerouslyUseHTMLString: true
					});
				}
      },
	
		onSlideStart (slide) {
      this.sliding = true
    },
    onSlideEnd (slide) {
      this.sliding = false
    },
		filterProduct(type){
		//console.log('clrsort:')
		 	if(type != ''){
				 this.products = this.allProducts
        this.products = this.products.filter( (product) => {
            //   this.lowerCase(product.name)
            //   this.lowerCase(this.search)
			//console.log('filfkkk')
              return product.type == type
          })
			 }else{
				 this.products = this.allProducts
			 }
		},
		changeItems(type){
			if(type == 'bestselling'){
				this.products = this.bestSelling
			}else if (type == 'latest'){
				this.products = this.latestItems
			}
		},
	},
	mounted(){
	},
   created () {
		 this.backToTop()
	  this.loading = true
      this.fetch = false
	   if(screen.width > 767){
       this.type = 'card'
     }else{
       this.type = ''
     }
     
//   },

//  beforeCreate() {
	   //console.log("home img")
	   
		  //console.log('this.loading', this.loading)
			//console.log("navigator.onLine", navigator.onLine)
		db.collection('shops').where('owner', '==', this.$route.params.storename)
		.onSnapshot(querySnapshot => {
       	 this.shops = []
     	 querySnapshot.forEach(doc => {
       		 const data = {
				'shoptype' : doc.data().shoptype,
				'shopcat' :doc.data().cat,
				'name': doc.data().name, 
				'details': doc.data().details,   
				'homeimg': doc.data().homeimg,
					'categories': doc.data().categories,
					'plan' : doc.data().plan,
					'txtcolor' : doc.data().txtcolor
        	}
				this.shops.push(data)
				this.shopcat = this.shops[0].shopcat
				this.color1 = this.shops[0].txtcolor
				//console.log("homeimg is", this.shops[0].homeimg)
				if(this.shops[0].homeimg != undefined){
					this.homeimg = this.shops[0].homeimg
				}else{
					this.homeimg = '../../../static/images/ecommerce.jpg'
				}
			this.name = this.shops[0].name
			this.stime = this.shops[0].details.stime
			this.etime = this.shops[0].details.etime
			this.tel1 = this.shops[0].details.tel1
			this.plan = this.shops[0].plan
			this.darea = this.shops[0].details.darea

				this.$store.state.secondaryDatabase.collection("shops").where('owner', '==', this.$route.params.storename)
			.onSnapshot((snapshot) => {
			this.shops2 = []
			snapshot.forEach( doc => {
						const data = {
					'id' : doc.id, 
					'categories': doc.data().categories,
					'curProducts': doc.data().curProducts
					}
				this.shops2.push(data)
				this.shopcats = this.shops2[0].categories
			})
				if(this.shops2[0].curProducts <= 40){
			
			//console.log(this.$store.state.starterplanproducts)
			if(this.$store.state.starterplanproducts[this.$route.params.storename] != undefined){
				
				this.allProducts = this.$store.state.starterplanproducts[this.$route.params.storename]
				this.products = this.allProducts 
				
				//console.log(this.products)
				//console.log('products from store!!!')
				this.loading = false
					this.fetch = true
			}else {
				
				this.$store.state.secondaryDatabase.collection("products").where('owner', '==', this.$route.params.storename)
				.onSnapshot((snapshot) => {
				this.allProducts = []
				snapshot.forEach( doc => {
					const data = {
						'id' : doc.id, 
						'color': doc.data().color ,
						'name': doc.data().name, 
						'price': doc.data().price,
						'disprice': doc.data().disprice,
						'image': doc.data().img,
						'subcat' : doc.data().subcat ,

						'brand' : doc.data().brand,
						'cond' : doc.data().cond,
								'warranty': doc.data().war,
						'desc' : doc.data().desc,
						'details' : doc.data().details,
						'otherimgs' : doc.data().otherimgs,  
							
				}
				this.allProducts.push(data)
				this.products = this.allProducts 
				this.$store.state.starterplanproducts[this.$route.params.storename] = this.products
				//console.log(this.products)
				})
					this.loading = false
					this.fetch = true
				})
				
				}
				}else{
					this.loading = false
					this.fetch = true
				}
			})

			this.$store.state.secondaryDatabase.collection('galleries').doc(this.$route.params.storename).get()
      .then(doc => {
        if(doc.data()){
          const data = {
          'id': doc.id,
          'gallery':doc.data().gallery, 
        }
        this.shops3.push(data)
        }
        
				if(!this.shops3[0]){
						this.shops3[0] = {}
						this.shops3[0].gallery = []
					}
				this.show = true
			}).catch(error => alert(error))

			
		 
			//console.log("homeimg is", this.homeimg)
			//console.log("name is", this.shops[0].name)
			//console.log("details are", this.shops[0].details)
		  ////console.log("url is", this.url)
		   
	  })
	  
	})
	// db.collection('shops').where('owner', '==', this.$route.params.storename).get().then(querySnapshot => {
	// 			const shops = []
	// 		querySnapshot.forEach(doc => {
	// 			const data = {
	// 			'id' : doc.id,
	// 			'shoptype' : doc.data().shoptype,
	// 			'visits': doc.data().visits,
	// 			'loc': doc.data().location,
	// 			'categories':doc.data().categories,
	// 			'plan':doc.data().plan,
	// 			'cat': doc.data().cat,
	// 			'details': doc.data().details,  
	// 			'config': doc.data().config
			
	// 		}
	// 		shops.push(data)
	// 		console.log(shops[0].config)
	// 		console.log(shops[0].id)
	// 		var secondaryAppConfig = shops[0].config
			
			// var secondary = firebase.initializeApp(this.$store.state.secondaryAppConfig, this.$route.params.storename)
			// this.$store.state.secondaryDatabase = secondary.firestore()
			// this.$store.state.secondaryApp = this.$route.params.storename
			// this.$store.state.secondaryDatabase.settings({timestampsInSnapshots: true,})
			// this.$store.state.secondaryDatabase.enablePersistence({experimentalTabSynchronization:true}).then(() => {
			// 	//console.log("Woohoo! Multi-Tab Persistence!");
			// });
			// console.log('secondaryDB', this.$store.state.secondaryDatabase)
		// })
		// })
			
		//  this.$store.state.secondaryDatabase.collection('offers')
    //   .limit(20).get().then(querySnapshot => {
    //     const offers = []
    //   querySnapshot.forEach(doc => {
    //     const data = {
    //       'id' : doc.id,
    //       'image': doc.data().img,
    //       'dis': doc.data().dis,
    //       'desc': doc.data().desc,
    //     }
    //     offers.push(data)
    //     this.$store.state.offers[this.$route.params.storename] = offers
    //     console.log(offers)
		// 	})
		// 	})

			if(this.plan != 'Starter'){
				 this.$store.state.secondaryDatabase.collection('products').where("owner", "==", this.$route.params.storename)
      .where("type", "==", "bestselling").limit(8).onSnapshot(querySnapshot => {
        this.bestSelling = []
      querySnapshot.forEach(doc => {
		  //console.log('this.bestSelling')
        const data = {
          'id' : doc.id,
		  'image': doc.data().img,
          'name': doc.data().name,
          'price': doc.data().price,
		  'disprice': doc.data().disprice
        }
				this.bestSelling.push(data)
				this.products = this.bestSelling
        //console.log(this.bestSelling)
          
	  })
			// this.loading = false
		  // this.fetch = true
		}) 
	   this.$store.state.secondaryDatabase.collection('products').where("owner", "==", this.$route.params.storename)
      .where("type", "==", "latest").limit(8).onSnapshot(querySnapshot => {
        this.latestItems = []
      querySnapshot.forEach(doc => {
		  //console.log('this.latestItems')
        const data = {
          'id' : doc.id,
		  'image': doc.data().img,
          'name': doc.data().name,
          'price': doc.data().price,
		  'disprice': doc.data().disprice
        }
        this.latestItems.push(data)
        //console.log(this.latestItems)
          
	  })
	
    })

	
				 
		} 
  }

}
</script>

<style scoped>
@import url('~@/assets/main/css/loading.css');
@media (max-width: 767px){
	.m-txt{
	  color:#6c7ae0;
	}
}
@media (max-width: 575px){
	.m-txt{
		font-size: 12px;
		line-height: 1.0;
  		letter-spacing: 0px;
		color:#6c7ae0;
	}
	.m-p-t-00{
		padding-top: 100px;
	}
}
.shophome{
	height: 60vh !important;
}
</style>




// WEBPACK FOOTER //
// src/components/store/Home.vue